import type { infer as zInfer } from "zod";
import { object, string } from "zod";

export const getLuminousIntegration = {
  name: "getLuminousIntegration" as const,
  input: object({}),
  output: object({
    luminousIntegration: object({
      apiDomain: string(),
      restockSetting: object({
        locationId: string(),
        warehouseId: string(),
      }).optional(),
    }).optional(),
  }),
};

export type LuminousIntegration = zInfer<typeof getLuminousIntegration.output>;
